/* Glow & Firm Pack (IT) - behaviour for templates/product.glow-pack-it.json
   Every label comes from section settings via data-* attributes, so text stays editable in the theme editor. */
(function () {
  'use strict';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  var money = function (cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  };

  /* ---------- reveal on scroll ---------- */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.gp-reveal:not(.in)');
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- gallery badge (moved from the hidden template into Shrine's media wrapper) ---------- */
  function initBadge() {
    var tpl = document.getElementById('gp-gallery-badge');
    var media = document.querySelector('[id$="__main"] .product__media-wrapper');
    if (!tpl || !media || media.querySelector('.gp-g-badge')) return;
    var b = document.createElement('div');
    b.className = 'gp-g-badge';
    b.textContent = tpl.getAttribute('data-text');
    media.appendChild(b);
  }

  /* ---------- quantity breaks -> free shipping bar + price per product ---------- */
  function selectedQty() {
    var r = document.querySelector('[id$="__main"] input[name="quantity"][type="radio"]:checked');
    return r ? parseInt(r.value, 10) || 1 : 1;
  }
  function initOffer() {
    var bar = document.querySelector('.gp-fship');
    var per = document.querySelector('.gp-offer-title [data-per]');
    function render() {
      var q = selectedQty();
      if (bar) {
        var need = parseInt(bar.dataset.threshold, 10) - q;
        var pct = Math.min(100, (q / parseInt(bar.dataset.threshold, 10)) * 100);
        bar.classList.toggle('done', need <= 0);
        bar.querySelector('.msg').innerHTML = need <= 0 ? bar.dataset.done : bar.dataset.todo.replace('[n]', need);
        var fill = bar.querySelector('.fill');
        requestAnimationFrame(function () { requestAnimationFrame(function () { fill.style.width = pct + '%'; }); });
      }
      if (per) {
        var prices = (per.dataset.per || '').split(',').map(Number);
        var idx = { 1: 0, 2: 1, 3: 2 }[q];
        if (idx !== undefined && prices[idx]) per.textContent = money(Math.round(prices[idx] / (5 * q))) + ' ' + per.dataset.label;
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'quantity' && e.target.type === 'radio') render();
    });
    render();
  }

  /* ---------- before / after sliders ---------- */
  function initSliders() {
    var sliders = document.querySelectorAll('.gp-ba:not([data-ready])');
    sliders.forEach(function (ba) {
      ba.setAttribute('data-ready', '1');
      var inp = ba.querySelector('input');
      inp.addEventListener('input', function () { ba.style.setProperty('--pos', inp.value + '%'); ba.classList.add('used'); });
    });
    if (!('IntersectionObserver' in window) || reduced) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var ba = e.target, inp = ba.querySelector('input'), t0 = null;
        function step(t) {
          if (ba.classList.contains('used')) return;
          if (t0 === null) t0 = t;
          var k = (t - t0) / 1400;
          if (k >= 1) { ba.style.setProperty('--pos', '50%'); inp.value = 50; return; }
          var v = 50 + Math.sin(k * Math.PI * 2) * 18;
          ba.style.setProperty('--pos', v + '%'); inp.value = v;
          requestAnimationFrame(step);
        }
        setTimeout(function () { requestAnimationFrame(step); }, 400);
      });
    }, { threshold: 0.6 });
    sliders.forEach(function (b) { io.observe(b); });
  }

  /* ---------- phone video: muted autoplay while visible, tap for sound ---------- */
  function initVideo() {
    document.querySelectorAll('.gp-phone:not([data-ready])').forEach(function (ph) {
      ph.setAttribute('data-ready', '1');
      var v = ph.querySelector('video'), snd = ph.querySelector('.snd');
      if (!v) { if (snd) snd.hidden = true; return; }
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
        }, { threshold: 0.4 }).observe(v);
      }
      if (snd) snd.addEventListener('click', function () {
        v.muted = !v.muted;
        if (!v.muted) { v.currentTime = 0; v.play().catch(function () {}); }
        snd.textContent = v.muted ? snd.dataset.off : snd.dataset.on;
      });
    });
  }

  /* ---------- reviews widget ---------- */
  function initReviews() {
    document.querySelectorAll('.gp-reviews:not([data-ready])').forEach(function (sec) {
      sec.setAttribute('data-ready', '1');
      var dataEl = sec.querySelector('script.gp-reviews-data');
      if (!dataEl) return;
      var cfg; try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var L = cfg.labels, list = cfg.reviews.map(function (r, i) { r._i = i; r.helpful = r.helpful || 0; return r; });
      if (!list.length) { sec.hidden = true; return; }
      var demo = cfg.demo, $ = function (s) { return sec.querySelector(s); };
      var AV = ['#d3192b', '#e46c8f', '#1f4fd1', '#6e1420', '#a80f1f', '#1f8a5b'];
      var flag = function (c) { return c ? String.fromCodePoint.apply(null, c.toUpperCase().split('').map(function (ch) { return 0x1F1A5 + ch.charCodeAt(0); })) : ''; };
      var stars = function (n) { return '★'.repeat(n) + '<span style="color:#e6d6d8">' + '★'.repeat(5 - n) + '</span>'; };
      var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
      var avg = list.reduce(function (s, r) { return s + r.stars; }, 0) / list.length;
      $('.gp-rv-avg').textContent = avg.toFixed(1).replace('.', ',');
      $('.gp-rv-stars').innerHTML = stars(Math.round(avg));
      $('.gp-rv-count').textContent = L.based.replace('[n]', list.length) + (demo ? ' (demo)' : '');
      var fStar = 0, fProd = 'all', sort = 'recent', shown = 6, voted = {};
      var dist = $('.gp-rv-dist');
      dist.innerHTML = [5, 4, 3, 2, 1].map(function (n) {
        var c = list.filter(function (r) { return r.stars === n; }).length;
        return '<button type="button" data-s="' + n + '"><span>' + n + ' ★</span><span class="bar"><i style="width:' + (c / list.length * 100) + '%"></i></span><span>' + c + '</span></button>';
      }).join('');
      dist.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          fStar = fStar === +b.dataset.s ? 0 : +b.dataset.s;
          dist.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', +x.dataset.s === fStar); });
          shown = 6; draw();
        });
      });
      var prods = ['all'];
      Object.keys(cfg.products).forEach(function (k) { if (list.some(function (r) { return r.product === k; })) prods.push(k); });
      var chips = $('.gp-rv-chips');
      chips.innerHTML = prods.map(function (k) { return '<button type="button" data-p="' + k + '" class="' + (k === 'all' ? 'on' : '') + '">' + esc(k === 'all' ? L.all : cfg.products[k]) + '</button>'; }).join('');
      chips.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { fProd = b.dataset.p; chips.querySelectorAll('button').forEach(function (x) { x.classList.toggle('on', x === b); }); shown = 6; draw(); });
      });
      $('.gp-rv-sort').addEventListener('change', function (e) { sort = e.target.value; draw(); });
      $('.gp-rv-more').addEventListener('click', function () { shown += 6; draw(); });
      var fmtDate = function (d) { try { return new Date(d + 'T12:00:00').toLocaleDateString('it-IT', { day: 'numeric', month: 'short', year: 'numeric' }); } catch (e) { return d; } };
      var sorters = {
        recent: function (a, b) { return String(b.date).localeCompare(String(a.date)); },
        helpful: function (a, b) { return b.helpful - a.helpful; },
        high: function (a, b) { return b.stars - a.stars || String(b.date).localeCompare(String(a.date)); },
        low: function (a, b) { return a.stars - b.stars || String(b.date).localeCompare(String(a.date)); }
      };
      function draw() {
        var r = list.filter(function (x) { return (!fStar || x.stars === fStar) && (fProd === 'all' || x.product === fProd); }).sort(sorters[sort]);
        var grid = $('.gp-rev-grid');
        grid.innerHTML = r.length ? r.slice(0, shown).map(function (x) {
          var v = voted[x._i] ? 1 : 0;
          return '<article class="gp-rev">' +
            '<div class="gp-rev-h"><span class="gp-stars">' + stars(x.stars) + '</span><time>' + esc(fmtDate(x.date)) + '</time></div>' +
            '<h4>' + esc(x.title) + '</h4><p>' + esc(x.text) + '</p>' +
            (x.product && cfg.products[x.product] ? '<span class="prod-tag">' + esc(cfg.products[x.product]) + '</span>' : '') +
            '<div class="who"><span class="av" style="background:' + AV[x._i % AV.length] + '">' + esc((x.name || '?').charAt(0)) + '</span>' +
            esc(x.name) + (x.city ? ' · ' + esc(x.city) : '') + ' ' + flag(x.country) +
            (!demo && x.verified ? ' <span class="ver">✓ ' + esc(L.verified) + '</span>' : '') +
            (demo ? ' <span class="demo">Demo</span>' : '') + '</div>' +
            '<div class="help">' + esc(L.helpful) + '<button type="button" data-i="' + x._i + '" class="' + (v ? 'done' : '') + '">👍 ' + (x.helpful + v) + '</button></div>' +
            '</article>';
        }).join('') : '<p class="gp-rv-empty">' + esc(L.empty) + '</p>';
        grid.querySelectorAll('.help button').forEach(function (b) {
          b.addEventListener('click', function () { var i = +b.dataset.i; voted[i] = !voted[i]; draw(); });
        });
        $('.gp-rv-more').hidden = r.length <= shown;
      }
      draw();
    });
  }

  function initAll() { initReveal(); initBadge(); initOffer(); initSliders(); initVideo(); initReviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  /* theme editor: re-init a section after it is edited */
  document.addEventListener('shopify:section:load', function () { initReveal(); initBadge(); initSliders(); initVideo(); initReviews(); });
})();
